$(window).on("scroll", function() {
    var sticky = $("#header-sticky"),
        shareSticky = $("#share-sticky"),
        scroll = $(window).scrollTop(),
        headerHeight = sticky.outerHeight(),
        marginTop = headerHeight + 48;

    if (scroll >= 260) {
        sticky.addClass("fixed-top");
        $('body').css({marginTop: `${marginTop}px`});
        shareSticky.css({top: `${headerHeight}px`});
    } else {
        sticky.removeClass("fixed-top");
        $('body').removeAttr('style');
        shareSticky.css({top: 0});
    }
});
